export default __webpack_public_path__ + "static/media/case-info-modal.337d6661.png";